import { render, staticRenderFns } from "./PartnerListAddNew.vue?vue&type=template&id=6b5800c6&"
import script from "./PartnerListAddNew.vue?vue&type=script&lang=js&"
export * from "./PartnerListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PartnerListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports